import Dashboard from "../Pages/Dashboard/Dashboard";
import Speciality from "../Pages/Masters/Speciality";
import Consultant from "../Pages/Masters/Consultant";
import ConsultantSpeciality from "../Pages/Masters/ConsultantSpeciality";
import Invoice from "../Pages/Invoice";
import Contractor from "../Pages/Masters/Contractor";
import Project from "../Pages/Masters/Project";
import User from "../Pages/Masters/User";
import ProjectList from "../Pages/Masters/ProjectList";
import ProjectProfile from "../Pages/ProjectProfileDetail/ProjectProfile";
import Client from "../Pages/Masters/Client";
import Items from "../Pages/Masters/Items";
import ProjectProfileEdite from "../Pages/ProjectProfileDetail/ProjectProfileEdite";
import ManageDocument from "../Components/ManageProject/Document";
import ManageContractorList from "../Components/ManageProject/ContractorList";
import ManageConsultantList from "../Components/ManageProject/ConsultantList";
import ManageGallery from "../Components/ManageProject/Gallery";
import Approvals from "../Pages/Approvals/Approvals";
import RequestList from "../Pages/Approvals/RequestList";
import Profile from "../Pages/Masters/Profile";
import ManageTask from "../Components/ManageProject/Task";
import ManageAddItems from "../Components/ManageProject/AddItem";
import ItemCategories from "../Pages/Masters/ItemCategories";
import InspectionForm from "../Pages/Approvals/InspectionForm";
import InspectionFormList from "../Pages/Approvals/InspectionFormList";
import ViewForm from "../Pages/Approvals/ViewForm";
import ManageRequestedInspection from "../Components/ManageProject/RequestedInspection";
import ViewInspection from "../Components/ViewInspection";
import Archives from "../Pages/Archives";
import TaskList from "../Pages/Dashboard/TaskList";
import PreviewProject from "../Pages/PreviewProject";
import RequestTamplate from "../Pages/Masters/RequestTamplate";
import TemplateItems from "../Pages/Masters/TemplateItems";
import DocumentRequest from "../Pages/Masters/DocumentRequest";
import RequestItems from "../Pages/Masters/RequestItems";



// routes.js
const routes = [
  ////////////////////// Dashboard Routing ///////////////////////////
  { path: "/", element: <Dashboard /> },
  { path: "/Invoice/:order_id", element: <Invoice /> },
  { path: "/TaskList/:status?", element: <TaskList /> },

  ////////////////////// Master's Routing ///////////////////////////
  { path: "/Contractor", element: <Contractor /> },
  { path: "/Projects/:projectId?", element: <Project /> },
  { path: "/ProjectList", element: <ProjectList /> },
  { path: "/Client", element: <Client /> },
  { path: "/Items", element: <Items /> },
  { path: "/EditProfile/:projectId?", element: <ProjectProfileEdite /> },
  { path: "/Speciality", element: <Speciality /> },
  { path: "/Consultant", element: <Consultant /> },
  { path: "/ConsultantSpeciality", element: <ConsultantSpeciality /> },
  { path: "/Profile", element: <Profile /> },
  { path: "/User", element: <User /> },
  { path: "/CreateCategories", element: <ItemCategories /> },
  { path: "/RequestTamplate", element: <RequestTamplate /> },
  { path: "/TemplateItems/:requirement_id", element: <TemplateItems /> },
  { path: "/DocumentRequest", element: <DocumentRequest /> },
  { path: "/RequestItems/:requirements_request_id", element: <RequestItems /> },




  //////////////////// Project's Routing ///////////////////////////
  { path: "/ProjectProfile/:projectId?", element: <ProjectProfile /> },
  { path: "/Documents/:projectId?", element: <ManageDocument /> },
  { path: "/ContractorList/:projectId?", element: <ManageContractorList /> },
  { path: "/ConsultantList/:projectId?", element: <ManageConsultantList /> },
  { path: "/Gallery/:projectId?", element: <ManageGallery /> },
  { path: "/Task/:projectId?", element: <ManageTask /> },
  { path: "/AddItem/:projectId?", element: <ManageAddItems /> },
  { path: "/Inspection/:projectId?", element: <ManageRequestedInspection /> },



  ////////////////////// Approvals ///////////////////////////
  { path: "/Approvals", element: <Approvals /> },
  { path: "/RequestList/:project_id?", element: <RequestList /> },
  { path: "/InspectionForm/:inspection_id?", element: <InspectionForm /> },
  { path: "/InspectionFormList", element: <InspectionFormList /> },
  { path: "/ViewForm/:inspection_id?", element: <ViewForm /> },

  ////////////////////// Others ///////////////////////////
  { path: "/Archives", element: <Archives /> },
  { path: "/PreviewProject/:project_id?", element: <PreviewProject /> },
];

export default routes;
